import { render, staticRenderFns } from "./CustomerProfileView.vue?vue&type=template&id=bf9a28d6&scoped=true"
import script from "./CustomerProfileView.vue?vue&type=script&lang=js"
export * from "./CustomerProfileView.vue?vue&type=script&lang=js"
import style0 from "./CustomerProfileView.vue?vue&type=style&index=0&id=bf9a28d6&prod&scoped=true&lang=css"
import style1 from "./CustomerProfileView.vue?vue&type=style&index=1&id=bf9a28d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9a28d6",
  null
  
)

export default component.exports